// extracted by mini-css-extract-plugin
module.exports = {"container":"modal_confirmation_container-module__container--THwcB","overlay":"modal_confirmation_container-module__overlay--2eOJW"};